module.exports = __webpack_public_path__ + "static/media/jessie-icon.cc2f5bd4.png";